import React from "react";
import { Link } from "react-router-dom";
import './Footer.scss';

export default class Footer extends React.Component{
    render(){
        return (
            <footer id="footer">
                <div className="container full-h">
                    <div className="ribbon">
                        <div className="logo">
                        </div>
                    </div>
                    <div id="menu-footer" className="menu-footer-container">
                        <ul id="menu-bottom-navigation" className="">
                            <li className="menu-item main-menu-item order-0">
                            <span className="wrapper-menu">
                                <a className="menu-link main-menu-link" href="https://binus.ac.id">BINA NUSANTARA</a>
                            </span>
                            </li>
                            <li className="menu-item menu-item-has-children main-menu-item order-0">
                            <span className="wrapper-menu">
                                <span className="menu-link main-menu-link">BINUS Higher Education</span>
                                <span className="parent-pointer"></span>
                            </span>
                            <ul className="sub-menu menu-depth-1">
                                <li className="menu-item sub-menu-item vertical-menu-item order-0">
                                <span className="wrapper-menu">
                                    <a className="menu-link sub-menu-link" href="https://binus.ac.id/">BINUS Greater Jakarta</a>
                                </span>
                                </li>
                                <li className="menu-item sub-menu-item vertical-menu-item order-0">
                                <span className="wrapper-menu">
                                    <a className="menu-link sub-menu-link" href="https://binus.ac.id/bandung">BINUS Bandung</a>
                                </span>
                                </li>
                                <li className="menu-item sub-menu-item vertical-menu-item order-0">
                                <span className="wrapper-menu">
                                    <a className="menu-link sub-menu-link" href="https://binus.ac.id/bekasi">BINUS Bekasi</a>
                                </span>
                                </li>
                                <li className="menu-item sub-menu-item vertical-menu-item order-0">
                                <span className="wrapper-menu">
                                    <a className="menu-link sub-menu-link" href="https://binus.ac.id/malang">BINUS Malang</a>
                                </span>
                                </li>
                                <li className="menu-item sub-menu-item vertical-menu-item order-0">
                                <span className="wrapper-menu">
                                    <a className="menu-link sub-menu-link" href="http://binus.ac.id/semarang">BINUS Semarang</a>
                                </span>
                                </li>
                            </ul>
                            </li>
                            <li className="menu-item menu-item-has-children main-menu-item order-0">
                            <span className="wrapper-menu">
                                <span className="menu-link main-menu-link" href="https://binus.edu/admissions/">Crowdbees</span>
                            </span>
                            <ul className="sub-menu menu-depth-1">
                                <li className="menu-item sub-menu-item vertical-menu-item order-0">
                                    <span className="wrapper-menu">
                                        <a className="menu-link sub-menu-link" href="https://forms.office.com/r/HRuuy9DzyV">Contact Support</a>
                                    </span>
                                </li>
                                <li className="menu-item sub-menu-item vertical-menu-item order-0">
                                    <span className="wrapper-menu">
                                        <Link to="/faq" className="menu-link sub-menu-link">Frequently Asked Question</Link>
                                    </span>
                                </li>
                            </ul>
                            </li>
                            <li className="menu-item menu-item-has-children main-menu-item order-0">
                            <span className="wrapper-menu">
                                <a className="menu-link main-menu-link" href="https://binus.ac.id/digital-transformation/">BINUS Digital Transformation</a>
                                <span className="parent-pointer"></span>
                            </span>
                            </li>
                        </ul>
                        </div>
                    <div className="copyright"> Copyright &copy; BINUS Higher Education. All rights reserved </div>
                </div>
            </footer>
        )
    }
}